import React from 'react';
import {
  TLinkProps,
  TParagraphProps,
  TStatusTextProps,
  TTextProps,
  TTitleProps,
} from './Typography.types';
import {
  SLink,
  SMessageLabel,
  SParagraph,
  SSecondaryText,
  SText,
  STitle,
} from './Typography.styles';

export const Title = ({ ...props }: TTitleProps) => {
  return <STitle {...props} />;
};

export const Text = ({ ...props }: TTextProps) => {
  return <SText {...props} />;
};

export const SecondaryText = ({ ...props }: TTextProps) => {
  return <SSecondaryText {...props} />;
};

export const Link = ({ ...props }: TLinkProps) => {
  return <SLink {...props} />;
};

export const Paragraph = ({ ...props }: TParagraphProps) => {
  return <SParagraph {...props} />;
};

export const MessageLabel = ({ ...props }: TTextProps) => {
  return <SMessageLabel {...props} />;
};

export const StatusText: React.FC<TStatusTextProps> = ({
  statusType,
  children,
  ...props
}) => {
  const getColor = () => {
    switch (statusType) {
      case 'TODO':
        return '#1B1A1C';
      case 'IN_PROGRESS':
        return '#0077A0';
      case 'STALLED':
        return '#EF426D';
      case 'COMPLETED':
        return '#179152';
      default:
        return '#1B1A1C';
    }
  };

  return (
    <SText style={{ color: getColor(), whiteSpace: 'nowrap' }} {...props}>
      {children}
    </SText>
  );
};
